export const AdditionalExampleModule: React.FC<CMS_Example_Content_Module_Data> = ({ title }) => {
  return <p>{title}</p>;
};
